import { ResourceReviewItem } from '../../../types';
import { MediaKind } from '../../../utils/assetTokens';
import { AnalysisAssetItem } from '../types';

// 资产选择器一批勾选会变成哪些素材种类——必须与 handleAddAssetRefs 的实际落库分支一一对应：
//   - 普通资产走 addShotAssetRef 建 AssetRef（非 shot_ref，恒为 image）；
//   - 已审核素材走 createRefResource 建 Resource，种类取 review.resourceType；
//   - 找不到匹配 review 的已审核素材在 handleAddAssetRefs 的循环里会被跳过（不落库），
//     所以这里也必须不计入，否则会拿一个根本不会发生的新增去拦用户。
// 已审核素材 → active 审核记录的匹配规则。分类与落库两处必须用同一份规则，
// 否则会出现"按 A 规则算超了拦下、按 B 规则其实根本不会新增"。
export function findActiveReviewForAsset(
  asset: AnalysisAssetItem,
  reviews: ResourceReviewItem[],
): ResourceReviewItem | undefined {
  return reviews.find(r =>
    r.status === 'active' && (asset.reviewId ? r.id === asset.reviewId : r.resourceUrl === asset.imageUrl)
  );
}

export function assetPickerAdditionKinds(
  assets: AnalysisAssetItem[],
  reviews: ResourceReviewItem[],
): MediaKind[] {
  return assets.flatMap((asset): MediaKind[] => {
    if (asset.state !== '__reviewed__') return ['image'];
    const review = findActiveReviewForAsset(asset, reviews);
    if (!review) return [];
    if (review.resourceType === 'video') return ['video'];
    if (review.resourceType === 'audio') return ['audio'];
    return ['image'];
  });
}
